import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function PriceBlock() {
  return <section id="precio" className="bg-beige py-24 px-6 md:px-12" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <FadeIn data-id="element-95">
          <div className="bg-white p-10 md:p-16 rounded-[3rem] shadow-xl text-center border border-amber/20 relative overflow-hidden" data-id="element-96">
            <div className="absolute top-0 left-0 w-full h-2 bg-amber" data-id="element-97"></div>

            <h2 className="text-3xl md:text-4xl mb-6 text-brown" data-id="element-98">
              Recuperá tu descanso hoy por solo
            </h2>

            <div className="flex justify-center items-baseline mb-2" data-id="element-99">
              <span className="text-3xl md:text-4xl font-serif text-brown/40 line-through mr-4" data-id="element-100">
                $23,900 ARS
              </span>
            </div>

            <div className="flex justify-center items-baseline mb-4" data-id="element-101">
              <span className="text-6xl md:text-8xl font-serif text-periwinkle font-bold" data-id="element-102">
                $8,990
              </span>
              <span className="text-2xl md:text-3xl text-brown/60 ml-2 font-serif" data-id="element-103">
                ARS
              </span>
            </div>

            <p className="text-sm text-brown/50 mb-8 uppercase tracking-wider font-semibold" data-id="element-104">
              Precio de lanzamiento · Oferta por tiempo limitado
            </p>

            <p className="text-xl md:text-2xl font-medium text-brown/80 mb-10 max-w-lg mx-auto" data-id="element-105">
              Un solo pago para terminar con meses de agotamiento crónico.
            </p>

            <div id="comprar" data-id="element-106">
              <CTAButton className="w-full md:w-auto px-12 py-5 text-xl" onClick={() => {
              trackAddToCart();
              window.open('https://viveencalma.com/cart/44200825356339:1', '_blank');
            }} data-id="element-107">
                Quiero empezar a dormir
              </CTAButton>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}